/* eslint-disable no-console */
import Konva from 'konva'
import LayoutGreenScreen from "@/layouts/green-screen/layout-green-screen.vue"

export default {
  name: "vInvent",
  components: {
    "layout-green-screen": LayoutGreenScreen
  },
  data() {
    return {
      stage: null,
      canvasWidth: null,
      canvasHeight: null,
      layerVideo: null,
      video: null,
      videoContext: null,
      tempVideo: null,
      tempVideoContext: null,
      chromakeyedVideo: null,
      videoWidth: null,
      videoHeight: null,
      computeInterval: null,
      chroma_key_sensitivity: this.$store.state.chroma_key_sensitivity,
      chromaKeyColor: this.$store.state.chroma_key_color,
      touched: 'init'
    }
  },
  methods: {
    async initializeVideo() {
      const mediaStream = await navigator.mediaDevices.getUserMedia({video: true});
      const video = document.getElementById('video');
      video.srcObject = mediaStream;
    },
    initializeCanvas() {
      const _this = this;

      this.video = document.getElementById('video');
      this.chromakeyedVideo =  document.getElementById('chromakeyedVideo')
      this.videoContext = this.chromakeyedVideo.getContext('2d');
      this.videoContext.width = this.videoWidth;
      this.videoContext.height = this.videoHeight;
      this.tempVideo = document.getElementById('tempChromakeyedVideo');
      this.tempVideoContext = document.getElementById('tempChromakeyedVideo').getContext('2d');
      this.tempVideoContext.width = this.videoWidth;
      this.tempVideoContext.height = this.videoHeight;

      this.stage = new Konva.Stage({
        container: 'container-canvas',
        width: this.canvasWidth,
        height: this.canvasHeight
      });

      this.layerChromakeyedVideo = new Konva.Layer();
      this.stage.add(this.layerChromakeyedVideo);
      this.layerVideo = new Konva.Layer();
      this.stage.add(this.layerVideo);

      // chromakeyed video
      let chromakeyedVideo = new Konva.Image({
        image: this.chromakeyedVideo,
        draggable: false,
        x: 0,
        y: 150
      });
      this.layerChromakeyedVideo.add(chromakeyedVideo);

      // video
      let video = new Konva.Image({
        image: this.video,
        draggable: false,
        x: 640,
        y: 150
      });
      this.layerVideo.add(video);

      if(!this.computeInterval) {
        this.computeInterval = setInterval(function(){
          _this.computeFrame();
          _this.layerChromakeyedVideo.draw();
          _this.layerVideo.draw();
        }, 50);
      }

      document.getElementById('video').addEventListener('loadedmetadata', function () {
        _this.videoWidth = document.getElementById('video').videoWidth;
        _this.videoHeight = document.getElementById('video').videoHeight;

        chromakeyedVideo.width(_this.videoWidth);
        chromakeyedVideo.height(_this.videoHeight);

        _this.chromakeyedVideo.width = _this.videoWidth;
        _this.chromakeyedVideo.height = _this.videoHeight;
        _this.tempVideo.width = _this.videoWidth;
        _this.tempVideo.height = _this.videoHeight;
      });
    },
    onVideoAreaClicked(evt) {
      const x = evt.clientX;
      const y = evt.clientY;

      let width = 1;
      let height = 1;

      const canvas = this.layerVideo.toCanvas({ x: x, y: y, width, height});
      const imageData = canvas.getContext('2d').getImageData(0, 0, width, height);
      const color = [imageData.data[0], imageData.data[1], imageData.data[2]];

      this.$store.commit('chroma_key_color', color);

      console.log(evt);
    },
    onVideoAreaTouched(evt) {
      const x = evt.pageX;
      const y = evt.pageY;

      let width = 1;
      let height = 1;

      const canvas = this.layerVideo.toCanvas({ x: x, y: y, width, height});
      const imageData = canvas.getContext('2d').getImageData(0, 0, width, height);
      const color = [imageData.data[0], imageData.data[1], imageData.data[2]];

      this.$store.commit('chroma_key_color', color);

      console.log(evt);
    },
    computeFrame: function() { // chromakey
      if(this.videoWidth > 0) {
        let frame = '';
        let backgroundFrame = null;
        let data = null;
        let l;
        let r; let g; let b;

        this.tempVideoContext.drawImage(this.video, 0, 0)

        frame = this.tempVideoContext.getImageData(0, 0, this.videoWidth, this.videoHeight)
        data = frame.data

        backgroundFrame = this.videoContext.getImageData(0, 0, this.videoWidth, this.videoHeight)

        l = data.length / 4
        while (l--) {
          r = data[l * 4]
          g = data[l * 4 + 1]
          b = data[l * 4 + 2]

          if (Math.abs(r - this.$store.getters.chromaKeyColorRGBArray[0]) < this.$store.state.chroma_key_sensitivity &&
                Math.abs(g - this.$store.getters.chromaKeyColorRGBArray[1]) < this.$store.state.chroma_key_sensitivity &&
                Math.abs(b - this.$store.getters.chromaKeyColorRGBArray[2]) < this.$store.state.chroma_key_sensitivity) {
            frame.data[l * 4] = backgroundFrame.data[l * 4]
            frame.data[l * 4 + 1] = backgroundFrame.data[l * 4 + 1]
            frame.data[l * 4 + 2] = backgroundFrame.data[l * 4 + 2]
            frame.data[l * 4 + 3] = 0
          }
        }

        this.videoContext.putImageData(frame, 0, 0)
      }
    },
    setDimensions() {
      this.canvasWidth = window.innerWidth;
      this.canvasHeight = window.innerHeight;
    }
  },
  computed: {
    getChromaKeyColor() {
      return this.$store.state.chroma_key_color;
    },
    getChromaKeyArray() {
      return this.$store.getters.chromaKeyColorRGBArray;
    }
  },
  watch: {
    chroma_key_sensitivity() {
      this.$store.commit('chroma_key_sensitivity', this.chroma_key_sensitivity);
    }
  },
  mounted() {
    this.setDimensions();
    this.initializeVideo();
    this.initializeCanvas();
  }
}
